<mdi-topbar [isHome]="false"></mdi-topbar>

<div
    class="mat-elevation-z8 container-fluid supplier-invoice-page"
    style="margin-top: 75px; width: 100%;">

    <div
        class="flex-row row"
        style="
            height: 45px;
            padding: 0px;
            margin-left: 0px;
            margin-right: 0px;
        ">

        <div class="col top-sidenav">

            <span class="horizontal-spacer5"></span>

            <span
                style="
                    margin-left: 45%;
                    font-size:large
                ">

                {{ 'wks_supplier_invoice' | translate }}

            </span>

        </div>

    </div>


    <div class="supplier-invoices-table">


        <!-- =====================================================
             Barre de recherche
             ===================================================== -->

        <div class="supplier-invoices-toolbar">


            <!-- Recherche référence -->

            <div class="supplier-invoices-search">

                <mat-form-field
                    appearance="outline"
                    class="search-field">

                    <mat-label>
                        {{ 'invoice reference' | translate }}
                    </mat-label>

                    <input
                        matInput
                        [(ngModel)]="criteria.search"
                        (keyup.enter)="
                            onSearchTextChange(
                                criteria.search
                            )
                        "
                        autocomplete="off">

                </mat-form-field>

            </div>


            <!-- Fournisseur -->

            <div class="supplier-invoices-supplier">

                <mat-form-field
                    appearance="outline"
                    class="supplier-field">

                    <mat-label>
                        {{ 'supplier' | translate }}
                    </mat-label>

                    <mat-select
                        [(ngModel)]="criteria.supplierId"
                        (selectionChange)="
                            onSupplierChange(
                                $event.value
                            )
                        ">

                        <mat-option [value]="null">

                            {{ 'All suppliers' | translate }}

                        </mat-option>


                        <mat-option
                            *ngFor="
                                let supplier
                                of suppliers
                            "
                            [value]="supplier.id">

                            {{ supplier.name }}

                        </mat-option>

                    </mat-select>

                </mat-form-field>

            </div>


            <!-- Date début -->

            <div class="supplier-invoices-date">

                <mat-form-field
                    appearance="outline">

                    <mat-label>
                        {{ 'date from' | translate }}
                    </mat-label>

                    <input
                        matInput
                        [matDatepicker]="dateFromPicker"
                        [(ngModel)]="criteria.dateFrom"
                        (dateChange)="
                            onDateFromChange(
                                $event.value
                            )
                        ">

                    <mat-datepicker-toggle
                        matSuffix
                        [for]="dateFromPicker">
                    </mat-datepicker-toggle>

                    <mat-datepicker
                        #dateFromPicker>
                    </mat-datepicker>

                </mat-form-field>

            </div>


            <!-- Date fin -->

            <div class="supplier-invoices-date">

                <mat-form-field
                    appearance="outline">

                    <mat-label>
                        {{ 'date to' | translate }}
                    </mat-label>

                    <input
                        matInput
                        [matDatepicker]="dateToPicker"
                        [(ngModel)]="criteria.dateTo"
                        (dateChange)="
                            onDateToChange(
                                $event.value
                            )
                        ">

                    <mat-datepicker-toggle
                        matSuffix
                        [for]="dateToPicker">
                    </mat-datepicker-toggle>

                    <mat-datepicker
                        #dateToPicker>
                    </mat-datepicker>

                </mat-form-field>

            </div>


            <!-- Boutons -->

            <div class="supplier-invoices-actions">


                <button
                    mat-raised-button
                    type="button"
                    (click)="onSearch()">

                    <mat-icon>
                        search
                    </mat-icon>

                    {{ 'Search' | translate }}

                </button>


                <button
                    mat-button
                    type="button"
                    (click)="resetSearch()">

                    <mat-icon>
                        clear
                    </mat-icon>

                    {{ 'Reset' | translate }}

                </button>


                <!-- Impression des factures sélectionnées -->

                <button
                    type="button"
                    class="mat-raised-button buttonTheme"
                    [disabled]="
                        getSelectedInvoiceCount() === 0
                    "
                    (click)="printSelectedInvoices()">

                    <span
                        class="fas fa-print"
                        style="margin-right:5px;">
                    </span>

                    {{ 'printSuppliersInvoices' | translate }}

                    <span
                        *ngIf="
                            getSelectedInvoiceCount() > 0
                        ">

                        ({{ getSelectedInvoiceCount() }})

                    </span>

                </button>

            </div>

        </div>


        <!-- =====================================================
             Indicateur de chargement
             ===================================================== -->

        <div
            class="supplier-invoices-loading"
            *ngIf="loadingIndicator">

            <mat-spinner
                diameter="40">
            </mat-spinner>

        </div>


        <!-- =====================================================
             AG Grid
             ===================================================== -->

        <div
            class="supplier-invoices-grid ag-theme-balham"
            style="
                width: 100%;
                height: 500px;
            ">

            <ag-grid-angular
                #agGrid
                style="
                    width: 100%;
                    height: 500px;
                "
                [gridOptions]="gridOptions"
                [columnDefs]="displayedColumns"
                [defaultColDef]="defaultColDef"
                [rowData]="rows"
                [localeText]="localeText"

                [rowSelection]="'multiple'"

                [animateRows]="true"
                [pagination]="true"
                [paginationPageSize]="30"

                (gridReady)="
                    onGridReady($event)
                "

                (rowClicked)="
                    onRowClicked($event)
                "

                (selectionChanged)="
                    onSelectionChanged()
                ">

            </ag-grid-angular>

        </div>

    </div>

</div>


<!-- =====================================================
     Historique des événements
     ===================================================== -->

<div
    class="supplier-invoice-history-overlay"
    *ngIf="historyPopupVisible">

    <div
        class="supplier-invoice-history-popup">

        <div
            class="supplier-invoice-history-popup-header">

            <span>
                {{ 'Invoice history' | translate }}
            </span>

            <span
                *ngIf="selectedInvoice">

                {{ selectedInvoice.ref }}

            </span>

            <button
                type="button"
                class="supplier-invoice-history-close"
                (click)="closeTrackingHistory()">

                <span class="fas fa-times"></span>

            </button>

        </div>


        <div
            class="supplier-invoice-history-popup-content">

            <div
                class="supplier-invoice-history-empty"
                *ngIf="
                    !invoiceTrackingEvents
                    || invoiceTrackingEvents.length === 0
                ">

                {{ 'No history available' | translate }}

            </div>


            <div
                class="supplier-invoice-history-event"
                *ngFor="
                    let event
                    of invoiceTrackingEvents
                ">

                <div
                    class="supplier-invoice-history-event-date">

                    {{
                        event.eventDate
                        | date:'dd/MM/yyyy HH:mm:ss'
                    }}

                </div>

                <div
                    class="supplier-invoice-history-event-type">

                    {{ event.eventType }}

                </div>

                <div
                    class="supplier-invoice-history-event-message"
                    *ngIf="event.message">

                    {{ event.message }}

                </div>

                <div
                    class="supplier-invoice-history-event-source"
                    *ngIf="event.source">

                    {{ event.source }}

                </div>

            </div>

        </div>


        <div
            class="supplier-invoice-history-popup-footer">

            <button
                type="button"
                class="btn btn-default"
                (click)="closeTrackingHistory()">

                {{ 'Close' | translate }}

            </button>

        </div>

    </div>

</div>


<!-- =====================================================
     PDF facture fournisseur - fenêtre latérale
     ===================================================== -->

<div
    class="supplier-invoice-pdf-panel"
    *ngIf="pdfPopupVisible">

    <div
        class="supplier-invoice-pdf-resize-handle"
        (pointerdown)="startPdfResize($event)">
    </div>


    <div
        class="supplier-invoice-pdf-panel-header">

        <span>
            {{ 'Supplier invoice PDF' | translate }}
        </span>

        <span
            *ngIf="selectedInvoice">

            {{ selectedInvoice.ref }}

        </span>

        <button
            type="button"
            class="supplier-invoice-pdf-panel-close"
            (click)="closePdf()">

            <span class="fas fa-times"></span>

        </button>

    </div>


    <div
        class="supplier-invoice-pdf-panel-content">

        <iframe
            *ngIf="pdfUrl"
            [src]="pdfUrl">
        </iframe>

    </div>


    <div
        class="supplier-invoice-pdf-panel-footer">

        <button
            type="button"
            class="btn btn-default"
            (click)="closePdf()">

            {{ 'Close' | translate }}

        </button>

    </div>

</div>
<!-- =====================================================
     PDF facture fournisseur - Attente fusion factures pour impression
     ===================================================== -->
<div
  *ngIf="waitingPrint"
    class="supplier-invoices-print-waiting">

    <mat-spinner
        diameter="50">
    </mat-spinner>

    <div>
        {{ 'printSupplierInvoicesWaiting' | translate }}
    </div>

</div>